import { render, staticRenderFns } from "./ComponentJsonEditor.vue?vue&type=template&id=3019566e&scoped=true"
import script from "./ComponentJsonEditor.vue?vue&type=script&lang=js"
export * from "./ComponentJsonEditor.vue?vue&type=script&lang=js"
import style0 from "./ComponentJsonEditor.vue?vue&type=style&index=0&id=3019566e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3019566e",
  null
  
)

export default component.exports